import { render, staticRenderFns } from "./zhekou.vue?vue&type=template&id=11ae6ffc"
import script from "./zhekou.vue?vue&type=script&lang=js"
export * from "./zhekou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports